import { Context, useContext, useSyncExternalStore } from "react";

import { ExtendedHistoryState, HistorySnapshot } from "./HistoryProvider";

/**
 * Hook to subscribe to history changes using useSyncExternalStore.
 * Returns the full history context plus the current snapshot (state and eventType).
 *
 * @example
 * const { state, eventType, set, undo, redo, clear } = useHistory(HistoryContext);
 * // Check eventType in your effect to respond to specific events
 * if (eventType === "undo" || eventType === "redo") { ... }
 */
export const useHistory = <S>(context: Context<ExtendedHistoryState<S>>): HistorySnapshot<S> & ExtendedHistoryState<S> => {
  const historyContext = useContext(context);

  const snapshot = useSyncExternalStore(historyContext.subscribe, historyContext.getSnapshot, historyContext.getSnapshot);

  return {
    ...snapshot,
    ...historyContext,
  };
};
